import Controller from './Controller';
import type Report from '../checks/Report';
import { Combined_DeleteTransition } from '../commands/combined';
import { CEMC_Transition } from '../commands/metamodel/complex';
import type { IModelVersion } from './Controller';
import type { OrId } from '../commands/types';
import type { ITransition } from '../../stores/model/metamodel/transition';
import type { IMethod } from '../../stores/model/metamodel/method';

/**
 * Controller to edit a transition of an FSM
 */
export default class EditTransitionController extends Controller {
  objectTypeId: string;
  fsmId: string;

  constructor(modelVersion: IModelVersion, objectTypeId: string, fsmId: string) {
    super(modelVersion);
    this.objectTypeId = objectTypeId;
    this.fsmId = fsmId;
  }

  async editTransition(id: OrId<ITransition>, methods: OrId<IMethod>[]): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = CEMC_Transition(model, this.objectTypeId, this.fsmId, id, methods);
      return checks;
    });
  }

  async deleteTransition(id: OrId<ITransition>): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_DeleteTransition(model, this.objectTypeId, this.fsmId, id);
      return checks;
    });
  }
}
